import type { WantedOverview } from "@/services/wanted/overview";

export function buildWantedOverviewRows(data: WantedOverview, nurseId: string) {
  const rows = data.nurses.map((nurse) => ({
    ...nurse,
    byDate: new Map(
      nurse.shifts
        .filter((shift) =>
          shift.shift_date.startsWith(
            `${data.year}-${String(data.month).padStart(2, "0")}-`
          )
        )
        .map((shift) => [shift.shift_date, shift.shift])
    ),
  }));
  return [
    ...rows.filter((row) => row.nurse_id === nurseId),
    ...rows.filter((row) => row.nurse_id !== nurseId),
  ];
}

export function summarizeWantedOverview(data: WantedOverview) {
  const dates = new Map<string, number>();
  for (const row of buildWantedOverviewRows(data, "")) {
    for (const date of row.byDate.keys())
      dates.set(date, (dates.get(date) ?? 0) + 1);
  }
  const total = [...dates.values()].reduce((sum, count) => sum + count, 0);
  const max = Math.max(0, ...dates.values());
  return {
    total,
    busiest: [...dates]
      .filter(([, count]) => count === max)
      .map(([date]) => date)
      .sort(),
    max,
  };
}
